<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>
    <ng-template pTemplate="header">{{lbl_workshop}}</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="redirectWorkShop()"></button>

        </ng-template>

    </p-toolbar>

    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{lbl_church_name}}</span>
                    <span class="p-text-bold">{{workShopDetail != null ? workShopDetail.chr.name : ""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_workshop}}</span>
                    <span class="p-text-bold">{{workShopDetail != null ? workShopDetail.wst.wsName : ""}} </span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_schedule}}</span>
                    <span class="p-text-bold">{{workShopDetail != null ? workShopDetail.f0.fromTime : ""}} -
                        {{workShopDetail != null ? workShopDetail.f0.toTime : ""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>Part 1a/2a</span>
                    <span class="p-text-bold">{{workShopDetail != null ? workShopDetail.f0.partN2s : ""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_10a15a_particip}}</span>

                    <span class="p-text-bold">{{workShopDetail != null ? workShopDetail.f0.partN15s : ""}}</span>
                </div>
            </p-panel>
        </div>
    </div>

    <p-table [columns]="cols" [value]="listParticipantAny" editMode="row" dataKey="guide.guideId"
        styleClass="p-datatable-responsive-demo">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
                <th style="width:8rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-editing="editing" let-ri="rowIndex">
            <tr [pEditableRow]="rowData">
                <td *ngFor="let col of columns">
                    <span class="p-column-title">{{ col.header}}</span>
                    <div style="text-align:center" *ngIf="rowData[col.field][col.fieldFirst][col.fieldSecond] == null">
                        {{rowData[col.field][col.fieldFirst]}}</div>

                    <div *ngIf="rowData[col.field][col.fieldFirst][col.fieldSecond] != null">

                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-checkbox [(ngModel)]="rowData[col.field][col.fieldFirst][col.fieldSecond]"
                                    binary="true" inputId="binary"
                                    [pTooltip]="rowData[col.field][col.fieldFirst]['sessNum']"></p-checkbox>
                            </ng-template>


                            <ng-template pTemplate="output">
                                <i class="pi" [ngClass]="{
                                    'pi-check-circle true-icon': rowData[col.field][col.fieldFirst][col.fieldSecond],
                                    'pi-times-circle false-icon': !rowData[col.field][col.fieldFirst][col.fieldSecond]
                                  }" [pTooltip]="rowData[col.field][col.fieldFirst]['sessNum']"></i>
                            </ng-template>
                        </p-cellEditor>
                    </div>

                </td>
                <td style="display:flex;justify-content: end;">
                    <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                        (click)="onRowEditInit(rowData,ri)" class="p-button-rounded p-button-warning p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                        (click)="onRowEditSave(rowData,ri)"
                        class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                        class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer" let-rowData let-columns="columns">
            <tr>
                <td style="text-align:center" colspan="3" class="p-text-right">Totals</td>
                <td *ngFor="let total of totalList">
                    {{total.isAssist}}
                </td>
            </tr>
        </ng-template>
    </p-table>

</p-fieldset>